var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column",class:'item_' + _vm.classSuffix},[_c('div',{staticClass:"add_date"},[_vm._v(_vm._s(_vm.dateFormatted))])])
}
var staticRenderFns = []

export { render, staticRenderFns }